export default {
    title: 'Les essentiels',
    subTitle: 'L’activité économique vue par Alan Mudie, Chief Investment Officer de Société Générale Private Banking.',
    keyFigures: [
          {
            title: 'Grand Paris Express',
            subTitle: 'Le chantier de tous les superlatifs',
            content: 'La France met en chantier le plus grand projet urbain de transport en commun d’Europe avec 200 kilomètres de nouvelles lignes automatiques (autant que le métro actuel) et 68 gares. La finalisation du projet est prévue pour 2030 et 35 milliards d’euros y seront consacrés. Le défi technique est remarquable puisque les nouvelles lignes seront creusées à une profondeur de 30 à 40 mètres en moyenne, parfois à plus de 50 mètres, alors que le métro parisien se situe à environ 10 mètres sous terre. Le projet vise à réduire la pollution et les embouteillages – Paris se situe au 7e rang des villes européennes les plus encombrées selon TomTom – et à dynamiser le développement économique du Grand Paris.',
        },
         {
            title: '',
            figure: 1.9,
            figureDecimals: 2,
            suffix: '%',
            content: 'L’inflation de base en zone euro s’est accélérée au mois d’avril suite à la forte accélération des prix de l’énergie, proche des objectifs de la Banque centrale européenne.',
            noCollapse: true,
 
        },

        {
            title: '',
            figure: 4,
            content: 'C’est le nombre de jours nécessaires pour créer une entreprise en France selon la Banque mondiale. En moyenne, il en faut 10 dans l’Union européenne, 9 en zone euro et 8 pour l’ensemble des pays membres de l’OCDE.',
            noCollapse: true,
 
        },

        {
            title: '',
            figure: 37,
            suffix: '%',
            content: 'Proportion de femmes dans les conseils d’administration des entreprises en France, selon Deloitte, en avance par rapport à la moyenne européenne, qui est de 22,6 %.',
            noCollapse: true,
 
        },
       {
            title: 'POSITIVE',
            content: 'Actuellement évaluée à Aa2, la France a vu la perspective de sa notation financière améliorée par l’agence Moody’s, puisqu’elle est passée de « stable » à « positive ».',
            noCollapse: true,
 
        },

 
    ]
};

